module.exports = __webpack_public_path__ + "img/IN-gray.d0f9456b.png";